export const RESTAURANT_STATS = 'RESTAURANT_STATS'
export const RESTAURANT_STATS_DETAILS = 'RESTAURANT_STATS_DETAILS'